export default __webpack_public_path__ + "static/media/history_img_1.77dc957d.png";